import helperFunctions from "./helper-functions";
import meetingModel from "@/store/orm-axios/models/Meeting";
import meetingResolutionModel from "@/store/orm-axios/models/MeetingResolution";
import mandateModel from "@/store/orm-axios/models/Mandate";
import resolutionVoteModel from "@/store/orm-axios/models/ResolutionVote";
import contactModel from "@/store/orm-axios/models/Contact";
let eventSource;

const meetingIRI = "/meetings/";
const meetingResolutionIRI = "/meeting_resolutions/";
const mandateIRI = "/mandates/";
const resolutionVoteIRI = "/resolution_votes/";
const contactIRI = "/contacts/";

export default {
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMeetingRegisterMercure();
      }
    },
  },
  destroyed() {
    eventSource.close();
  },
  methods: {
    async initMeetingRegisterMercure() {
      if (!this.isAuthenticatedForMercure && this.isDesktop) {
        await helperFunctions.loginWebFromDesktop();
      }

      if (eventSource) eventSource.close();

      const topics = [
        `${meetingIRI}{id}`,
        `${meetingResolutionIRI}{id}`,
        `${mandateIRI}{id}`,
        `${resolutionVoteIRI}{id}`,
        `${contactIRI}{id}`,
      ];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(meetingIRI)) {
          model = meetingModel;
        } else if (eventData["@id"].includes(meetingResolutionIRI)) {
          model = meetingResolutionModel;
        } else if (eventData["@id"].includes(mandateIRI)) {
          model = mandateModel;
        } else if (eventData["@id"].includes(resolutionVoteIRI)) {
          model = resolutionVoteModel;
        } else if (eventData["@id"].includes(contactIRI)) {
          model = contactModel;
        }

        helperFunctions.modifyInStore(eventData, model, eventData["@type"]);
      };
      helperFunctions.case401ErrorReload(eventSource);
    },
  },
};
